import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

var gqlSetAssetAvailableToLeaseFlag = gql`
  mutation setAssetAvailableToLease($organizationId: UUID!,$assetId: UUID!, $available: Boolean!) {
    setAssetAvailableToLease(organizationId: $organizationId, assetId: $assetId, available: $available) 
  }  
`;

export function apiSetAssetAvailableToLease(organizationId, assetId, published) {

    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        client
            .mutate({
                mutation: gqlSetAssetAvailableToLeaseFlag,
                variables: {organizationId, assetId, available:published},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                let data = result.data.setAssetAvailableToLease;
                console.log(data);
                if(data) resolve(data);
                else throw "Unable to set";
            })
            .catch((err) => {
                toast.error("Api Error, Unable to set available flag");
                reject(err);
            })
    });
}
